'use client'

import { useEffect } from 'react'

/**
 * Beacon de visualização do módulo "Posts Populares".
 * Registra 1 view por sessão/post (dedupe via sessionStorage) chamando /track/post-view.
 * Não renderiza nada nem exibe números — uso interno para o filtro "Mais lidas".
 */
export function PostViewBeacon({ postId }: { postId?: number | null }) {
  useEffect(() => {
    if (!postId || !Number.isFinite(postId)) return

    const key = `pv:${postId}`
    try {
      if (sessionStorage.getItem(key)) return
      sessionStorage.setItem(key, '1')
    } catch {
      // sessionStorage indisponível → segue sem dedupe.
    }

    const body = JSON.stringify({ postId })
    try {
      if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
        navigator.sendBeacon('/track/post-view', new Blob([body], { type: 'application/json' }))
      } else {
        void fetch('/track/post-view', {
          method: 'POST',
          body,
          keepalive: true,
          headers: { 'content-type': 'application/json' },
        })
      }
    } catch {
      // best-effort
    }
  }, [postId])

  return null
}
